import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class IFrameGuard  {

	constructor(private router:Router) { }

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		let urlOkay = environment.magento.whiteListUrls.some(u => document.referrer.startsWith(u));	
		if (!urlOkay) {
			console.error("Parent not allowed: ", document.referrer);
			this.router.navigate(['/error']);
		}
		return urlOkay;
	}
}
